import { RootState } from "redux/rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.stressCheckList.loading;
export const selectErrorMessage = (state: RootState) =>
  state.stressCheckList.error;
export const stressCheckListDataResponse = (state: RootState) =>
  state.stressCheckList.stressCheckListResponse;
